module.exports = __webpack_public_path__ + "img/1-1.7872e6f5.svg";